export default __webpack_public_path__ + "static/media/05.6fe7f4ce.jpg";